var exports = {
  "kL": "ScopeSheet.module__container___UTRpdG",
  "XG": "ScopeSheet.module__scroller___UTRpdG",
  "iy": "ScopeSheet.module__optionsContainer___UTRpdG",
  "uK": "ScopeSheet.module__option___UTRpdG",
  "h4": "ScopeSheet.module__optionSelected___UTRpdG",
  "ts": "ScopeSheet.module__optionLeft___UTRpdG",
  "H9": "ScopeSheet.module__optionIcon___UTRpdG",
  "AJ": "ScopeSheet.module__optionIconSelected___UTRpdG",
  "re": "ScopeSheet.module__optionText___UTRpdG",
  "ed": "ScopeSheet.module__optionLabel___UTRpdG",
  "tD": "ScopeSheet.module__optionLabelSelected___UTRpdG",
  "q3": "ScopeSheet.module__optionDescription___UTRpdG",
  "oE": "ScopeSheet.module__checkIcon___UTRpdG",
};

module.exports = exports;
